<template>
  <f7-panel class="addParticipantGroupRightPanel" right cover resizable @panel:opened="reducePageWidth"
    @panel:close="resetPageWidth" @panel:open="addCurrentParticipants()" :backdrop="false" :style="{
      'min-width': f7.width >= 768 ? '418px' : '100%',
      'border-left':
        'var(--f7-page-master-border-width) solid var(--f7-page-master-border-color)',
    }"><f7-view>
      <f7-page page-with-subnavbar>
        <f7-navbar no-shadow>
          <f7-nav-left>
            <f7-link panel-close>
              <f7-icon ios="f7:multiply" aurora="f7:multiply" md="material:close"></f7-icon>
            </f7-link>
          </f7-nav-left>

          <div class="title">
            {{ $t("tamtammessage.addANewParticipant") }}
          </div>
          <f7-subnavbar :inner="false" no-shadow class="no-shadow">
            <f7-searchbar search-container=".search-UserList" search-in=".item-title, .item-after, .item-footer"
              :disable-button="!theme.aurora" :backdrop="false"></f7-searchbar>
          </f7-subnavbar>
        </f7-navbar>

        <f7-list dividers-ios strong-ios class="searchbar-not-found">
          <f7-list-item :title="$t('common.nothingFound')"></f7-list-item>
        </f7-list>
        <f7-block strong v-show="newGroupParticipants && newGroupParticipants.length > 0">
          <f7-chip outline v-for="(grpParticipant, index) in newGroupParticipants" :key="index"
            :text="grpParticipant.name" deleteable @click="deleteParticipantChip(grpParticipant)"><template #media>
              <img v-if="!!grpParticipant.logo" :src="`${grpParticipant.logo}`" style="
                  width: var(--f7-chip-height);
                  height: var(--f7-chip-height);
                  border-radius: 50%;
                " />
              <img v-else-if="!!grpParticipant.avatar" :src="`${grpParticipant.avatar}`" style="
                  width: var(--f7-chip-height);
                  height: var(--f7-chip-height);
                  border-radius: 50%;
                " />
              <f7-badge v-else color="auto" style="
                  width: var(--f7-chip-height);
                  height: var(--f7-chip-height);
                  border-radius: 50%;
                ">{{ $filtersGetInitial.getInitial(grpParticipant.name) }}</f7-badge>
            </template>
          </f7-chip>
        </f7-block>
        <f7-list dividers-ios strong-ios media-list no-chevron class="search-UserList searchbar-found">
          <f7-list-item v-for="(user, index) in users" :key="index" checkbox :title="user.name"
            @change="selectParticipant(user)" :after="user.phoneNumber" :footer="user.tag" :disabled="chatParticipantList &&
                chatParticipantList.length > 0 &&
                chatParticipantList.findIndex((x) => x.userId === user.userId)
                ? true
                : false
              " :name="'participant' + user.userId" :checked="newGroupParticipants.findIndex((x) => x.userId === user.userId) >= 0
              " :value="user.userId" :class="'newGroupParticipant' + user.userId">
            <template #media>
              <img v-if="!!user.logo" :src="`${user.logo}`" width="40"
                style="height: 48px; width: 48px; border-radius: 25px" badge="+" badge-color="auto" />

              <f7-badge color="auto" badge="+" badge-color="auto" v-else-if="user.logo === null && user.name !== null"
                style="height: 48px; width: 48px; font-size: 16px; border-radius: 25px">{{
                  $filtersGetInitial.getInitial(user.name) }}</f7-badge>
            </template>
          </f7-list-item>
        </f7-list>

        <f7-button v-if="newGroupParticipants && newGroupParticipants.length >= 1" raised fill round-ios large
          ripple class="buttons" color="red" icon-ios="f7:arrow_up_circle_fill" icon-md="material:send" strong
          @click="addNewParticipants()">
          {{ $t("tamtammessage.addParticipants") }}
        </f7-button>
      </f7-page>
    </f7-view>
  </f7-panel>
</template>
<style scoped></style>
<script setup>
import { ref, computed, watchEffect } from "vue";
import { f7, theme } from "framework7-vue";
import { useMessageStore } from "../../js/pinia-stores/message.js";
import { useAccountStore } from "../../js/pinia-stores/account.js";
import { useTabletScreen } from "../../js/composables/useMediaQuery.js";
import { useMessageOptions, useMessageGroup } from "../../js/composables/useMessage.js";
import _ from "lodash";

const props = defineProps({

  chatParticipantList: { type: Array, default: () => [] },
});

// Local state
const participantsToAdd = ref([]);
const newGroupParticipants = ref([]);
// Store accessors (only those actually consumed below)
const messageStore = useMessageStore();
const accountStore = useAccountStore();
const group = computed(() => messageStore.group);
const users = computed(() => accountStore.users);
const isTablet = useTabletScreen().matches;
// Seed newGroupParticipants from the current chat participants whenever they change
watchEffect(() => {
  if (props.chatParticipantList && props.chatParticipantList.length > 0) {
    newGroupParticipants.value = _.cloneDeep(props.chatParticipantList);
  }
});


const {
  addCurrentParticipants,
  selectParticipant,
  deleteParticioantChip,
  addNewParticipants,
} = useMessageGroup({
  isTablet,
  newGroupParticipants,
  participantsToAdd,
  group,
  chatGroupParticipantList: computed(() => props.chatParticipantList),
});

const { reducePageWidth, resetPageWidth } = useMessageOptions({ isTablet });

// Public name expected by the template (spelling fix would be a separate concern)
const deleteParticipantChip = deleteParticioantChip;
</script>
